export const POKEMON_COLORS = {
  1: '#7da68d',
  2: '#799b9d',
  3: '#818783',
  4: '#cda485',
  5: '#d38d7d',
  6: '#b79b7c',
  7: '#8fa9ae',
  8: '#b4c3d1',
  9: '#91939e',
  10: '#a2ac71',
  11: '#8cb265',
  12: '#bfc2ca',
  13: '#b89376',
  14: '#c5b05d',
  15: '#bab6ad',
  16: '#b4a07c',
  17: '#c2ab8b',
  18: '#c8ae8c',
  19: '#a390a7',
  20: '#b59978',
  21: '#bc8c7f',
  22: '#b68e6b',
  23: '#a38096',
  24: '#8d8192',
  25: '#d7bb70',
  26: '#d0b381',
  27: '#c2b186',
  28: '#ae966f',
  29: '#b3bdd1',
  30: '#9cb5bf',
  31: '#8a99a4',
  32: '#917694',
  33: '#a084a0',
  34: '#a389a0',
  35: '#e1bdc3',
  36: '#ddc5bf',
  37: '#be7f62',
  38: '#ded3a1',
  39: '#d5b7c0',
  40: '#dccdd3',
  41: '#7f6a90',
  42: '#846a91',
  43: '#5f9272',
  44: '#907276',
  45: '#b77e8d',
  46: '#c89374',
  47: '#c78b78',
  48: '#8e779b',
  49: '#cdc3d3',
  50: '#a28b83',
  51: '#97837b',
  52: '#c8b9a2',
  53: '#d1c1a2',
  54: '#dec49a',
  55: '#7b9bb6',
  56: '#d1c0b3',
  57: '#b8a395',
  58: '#c5a78c',
  59: '#c1a183',
  60: '#97a5bb',
  61: '#98a4ba',
  62: '#94a3bb',
  63: '#cab958',
  64: '#beab57',
  65: '#c0b168',
  66: '#98acb4',
  67: '#9597ab',
  68: '#8a96a2',
  69: '#afbf81',
  70: '#b6c083',
  71: '#aabe76',
  72: '#848fa3',
  73: '#898f9f',
  74: '#a4a098',
  75: '#a5a59a',
  76: '#89817e',
  77: '#e5c294',
  78: '#e3b78f',
  79: '#d8adb5',
  80: '#c7aeb0',
  81: '#a9afb4',
  82: '#a5a9ae',
  83: '#a89a87',
  84: '#b69475',
  85: '#ad8e7b',
  86: '#d8dde5',
  87: '#dfe4eb',
  88: '#9985a0',
  89: '#918395',
  90: '#8d84a0',
  91: '#7d798e',
  92: '#8b7f91',
  93: '#746a7e',
  94: '#827c9a',
  95: '#82828c',
  96: '#bba457',
  97: '#dbc86d',
  98: '#c39a8a',
  99: '#be9381',
  100: '#d1abac',
  101: '#cec6ce',
  102: '#ddcaca',
  103: '#93a484',
  104: '#c5beaf',
  105: '#b8aea5',
  106: '#ab9c95',
  107: '#ab9494',
  108: '#d5afb0',
  109: '#a39fa4',
  110: '#9a929c',
  111: '#7d868e',
  112: '#92939b',
  113: '#e1c0cc',
  114: '#798193',
  115: '#b4a391',
  116: '#9dc3d0',
  117: '#8fb8c7',
  118: '#d2c4ca',
  119: '#c6b7b7',
  120: '#a79363',
  121: '#9e9195',
  122: '#b69fa9',
  123: '#acbfa1',
  124: '#c3978a',
  125: '#ae996a',
  126: '#c28e5d',
  127: '#999091',
  128: '#a18566',
  129: '#cd9b89',
  130: '#81909a',
  131: '#81a4ba',
  132: '#b6a5c7',
  133: '#aa8b6a',
  134: '#86afb8',
  135: '#d1ba82',
  136: '#c69b6e',
  137: '#a39da3',
  138: '#b7c0b0',
  139: '#a2afa7',
  140: '#97775e',
  141: '#a18a76',
  142: '#a297a9',
  143: '#b2b3b1',
  144: '#6e9fbe',
  145: '#c9ac6f',
  146: '#e4a671',
  147: '#bec2ce',
  148: '#b0c1d4',
  149: '#caae84',
  150: '#b6aab8',
  151: '#d5afbd',
  152: '#aac190',
  153: '#c1b984',
  154: '#c2b091',
  155: '#c9a67c',
  156: '#d0a975',
  157: '#d4b67a',
  158: '#719193',
  159: '#97a299',
  160: '#87a7b3',
  161: '#a28477',
  162: '#baa18b',
  163: '#ab8e80',
  164: '#927d6a',
  165: '#c5b092',
  166: '#b09487',
  167: '#9ca777',
  168: '#a37974',
  169: '#727692',
  170: '#9f9fa4',
  171: '#9295a9',
  172: '#beb483',
  173: '#d2b1a8',
  174: '#e2cccd',
  175: '#d8d0ba',
  176: '#cdd5c7',
  177: '#9b9858',
  178: '#aba48d',
  179: '#bab099',
  180: '#bea6ae',
  181: '#d5bf90',
  182: '#b39e6e',
  183: '#70a2c3',
  184: '#819eb6',
  185: '#907e60',
  186: '#a9bb6b',
  187: '#be9288',
  188: '#9bb862',
  189: '#b9b7b7',
  190: '#b59e9c',
  191: '#a29d5f',
  192: '#bbc17f',
  193: '#af927e',
  194: '#8faec3',
  195: '#89acbc',
  196: '#bda3b7',
  197: '#5e5f57',
  198: '#595f66',
  199: '#d1afa7',
  200: '#637082',
  201: '#848c93',
  202: '#6699b4',
  203: '#ad8046',
  204: '#4e6568',
  205: '#a88d92',
  206: '#cac898',
  207: '#b583a9',
  208: '#7b8094',
  209: '#be858b',
  210: '#c09eb5',
  211: '#95a588',
  212: '#9d585a',
  213: '#cba76e',
  214: '#5e7c95',
  215: '#867f89',
  216: '#c99266',
  217: '#9a7b64',
  218: '#d87c63',
  219: '#b8736a',
  220: '#9b7a6a',
  221: '#a38072',
  222: '#df909c',
  223: '#adbeb2',
  224: '#cd6856',
  225: '#c3a1a0',
  226: '#a59dab',
  227: '#9d93a4',
  228: '#7b6f69',
  229: '#7c6f6b',
  230: '#789eaf',
  231: '#89b6b6',
  232: '#8c969e',
  233: '#a189a3',
  234: '#ae9077',
  235: '#c0b5a3',
  236: '#ac98a1',
  237: '#90868a',
  238: '#cdb390',
  239: '#d1be76',
  240: '#c7877b',
  241: '#c5a59a',
  242: '#d6b0b8',
  243: '#b7a587',
  244: '#8c776a',
  245: '#929fa9',
  246: '#8b9376',
  247: '#909bb4',
  248: '#8a967d',
  249: '#c7c9d6',
  250: '#c28e6a',
  251: '#bcccb1',
  252: '#afbb76',
  253: '#8c9d7a',
  254: '#83a97f',
  255: '#e6af5b',
  256: '#d6b286',
  257: '#cfa681',
  258: '#9ab1c3',
  259: '#96aaa9',
  260: '#8393a5',
  261: '#a09f9f',
  262: '#757575',
  263: '#a69483',
  264: '#b5aaa6',
  265: '#cda69c',
  266: '#d7dbe3',
  267: '#9a8b78',
  268: '#cbc0d1',
  269: '#aba275',
  270: '#6ea081',
  271: '#8eaa82',
  272: '#b6ba8e',
  273: '#a69d90',
  274: '#aa9d91',
  275: '#aaa99f',
  276: '#8e808e',
  277: '#7e6b81',
  278: '#d4d7db',
  279: '#d0cab2',
  280: '#b1beb0',
  281: '#afbda8',
  282: '#ccd6cb',
  283: '#91b8c3',
  284: '#d5c2c3',
  285: '#cbc1ae',
  286: '#b1ac91',
  287: '#c6bcb2',
  288: '#d6d2d3',
  289: '#b5aaa1',
  290: '#c2c3c2',
  291: '#beb5b0',
  292: '#ad9986',
  293: '#d5bab8',
  294: '#9e93a6',
  295: '#a7a1b3',
  296: '#d7c392',
  297: '#cead8c',
  298: '#45a1d3',
  299: '#6d719b',
  300: '#e2c0af',
  301: '#bfa2a2',
  302: '#7f6f9c',
  303: '#9e9076',
  304: '#b3b6b8',
  305: '#b0b2b5',
  306: '#8b8b8e',
  307: '#b3c5d0',
  308: '#cc9098',
  309: '#a4b88f',
  310: '#a8b09e',
  311: '#cead93',
  312: '#b5c5bc',
  313: '#a78d93',
  314: '#99a2ac',
  315: '#8ea191',
  316: '#a1be8d',
  317: '#8c84af',
  318: '#b0927a',
  319: '#7e869c',
  320: '#afada3',
  321: '#8895a1',
  322: '#ead49d',
  323: '#ba8f88',
  324: '#bfa596',
  325: '#a69da1',
  326: '#978896',
  327: '#c9a59b',
  328: '#d49175',
  329: '#728e69',
  330: '#a7aa88',
  331: '#92af80',
  332: '#a1bb8f',
  333: '#d2e6f2',
  334: '#c9dbe6',
  335: '#d8ccd2',
  336: '#858081',
  337: '#baaf8c',
  338: '#caa46d',
  339: '#7e9dad',
  340: '#667e93',
  341: '#d49e8a',
  342: '#a3716d',
  343: '#ae997f',
  344: '#8f7576',
  345: '#ba9ba6',
  346: '#b1b594',
  347: '#a29c9a',
  348: '#8f99a4',
  349: '#a6a093',
  350: '#c8b1a3',
  351: '#cacdd3',
  352: '#bbc07e',
  353: '#6b7b9d',
  354: '#878480',
  355: '#a4a49c',
  356: '#aca8a5',
  357: '#869c73',
  358: '#cdc5cc',
  359: '#c6cad4',
  360: '#8ab7bd',
  361: '#b7a184',
  362: '#959fab',
  363: '#c2c5cc',
  364: '#abc5d1',
  365: '#75aac3',
  366: '#79899e',
  367: '#aeb0b4',
  368: '#d8abc5',
  369: '#8c8076',
  370: '#e0949f',
  371: '#9bb7c0',
  372: '#c4c6c8',
  373: '#878695',
  374: '#799caf',
  375: '#678392',
  376: '#668e9e',
  377: '#af9a97',
  378: '#93c3d4',
  379: '#8d8f93',
  380: '#b8a1ae',
  381: '#7395b3',
  382: '#6679a7',
  383: '#a56865',
  384: '#60856b',
  385: '#d8d3b2',
  386: '#ab8170',
  387: '#a3ae76',
  388: '#85905d',
  389: '#778369',
  390: '#d0a371',
  391: '#b58d6f',
  392: '#bd9275',
  393: '#8da9b9',
  394: '#7e8c91',
  395: '#6c6f75',
  396: '#857a77',
  397: '#82746e',
  398: '#8d796d',
  399: '#9f7f5c',
  400: '#a4875b',
  401: '#af876c',
  402: '#a1624e',
  403: '#7c9699',
  404: '#6d7a76',
  405: '#5b615e',
  406: '#9dba6c',
  407: '#9fadae',
  408: '#758a9e',
  409: '#6a7380',
  410: '#9c8f7c',
  411: '#8f8a81',
  412: '#9d9276',
  413: '#6b9267',
  414: '#caa561',
  415: '#cba471',
  416: '#9d7f59',
  417: '#bbd5dc',
  418: '#c68d62',
  419: '#cda974',
  420: '#ad7b6a',
  421: '#71686e',
  422: '#a3a3a4',
  423: '#919282',
  424: '#b99a93',
  425: '#b0a2a7',
  426: '#ad9a9a',
  427: '#bda37c',
  428: '#c9b086',
  429: '#85608a',
  430: '#62636f',
  431: '#93929d',
  432: '#aba6ae',
  433: '#cba876',
  434: '#8d7c7e',
  435: '#948585',
  436: '#537f8a',
  437: '#689390',
  438: '#919769',
  439: '#b4a2a9',
  440: '#dbbebe',
  441: '#7f8384',
  442: '#bda29b',
  443: '#71808b',
  444: '#81728c',
  445: '#7a6d7b',
  446: '#7e8d94',
  447: '#617883',
  448: '#6f7d80',
  449: '#ac9766',
  450: '#a39374',
  451: '#858ba3',
  452: '#8a7494',
  453: '#7b7f95',
  454: '#767791',
  455: '#94a96e',
  456: '#91979d',
  457: '#758e8f',
  458: '#719bba',
  459: '#abb1af',
  460: '#bcc3c5',
  461: '#9f6f7a',
  462: '#86898e',
  463: '#c88b8e',
  464: '#8e6b62',
  465: '#6e7f99',
  466: '#a08d63',
  467: '#bb7845',
  468: '#b7c6c5',
  469: '#a98e80',
  470: '#b2bc92',
  471: '#86b2b4',
  472: '#7e7a8b',
  473: '#ac9a8a',
  474: '#8a8899',
  475: '#9ca99c',
  476: '#82646e',
  477: '#827e6f',
  478: '#bdbfc0',
  479: '#c0c6c2',
  480: '#b0ac9d',
  481: '#b4a3b9',
  482: '#88a4b4',
  483: '#798799',
  484: '#b1aab4',
  485: '#8e7c75',
  486: '#a9a48f',
  487: '#8b7c68',
  488: '#c7acac',
  489: '#6fa4b1',
  490: '#71aeb9',
  491: '#716a6a',
  492: '#abac87',
  493: '#a7a59d',
  494: '#cfaa85',
  495: '#a0ae77',
  496: '#a4b884',
  497: '#7da27a',
  498: '#ab7650',
  499: '#ae7648',
  500: '#a17551',
  501: '#b6c3c4',
  502: '#7e9ba4',
  503: '#91979d',
  504: '#b69b80',
  505: '#b28e6c',
  506: '#cda97d',
  507: '#a3897a',
  508: '#afa695',
  509: '#957e8b',
  510: '#93766e',
  511: '#93b17d',
  512: '#87af7c',
  513: '#d3926d',
  514: '#c99074',
  515: '#a6bbad',
  516: '#92b6b3',
  517: '#e1bdc6',
  518: '#d2a1b5',
  519: '#aba59f',
  520: '#9d9797',
  521: '#6d6461',
  522: '#8f8c87',
  523: '#8c8c8d',
  524: '#675b55',
  525: '#674955',
  526: '#7f4d54',
  527: '#909aa3',
  528: '#6a7483',
  529: '#9c9595',
  530: '#857a7a',
  531: '#e0b7a8',
  532: '#a38d7e',
  533: '#a28483',
  534: '#978a83',
  535: '#a0a193',
  536: '#8f9a95',
  537: '#5a8395',
  538: '#a7938c',
  539: '#6d8b98',
  540: '#aba857',
  541: '#92b242',
  542: '#97a94d',
  543: '#965158',
  544: '#807681',
  545: '#804757',
  546: '#b9c7b4',
  547: '#cccaac',
  548: '#b0c78e',
  549: '#a1ac70',
  550: '#85a287',
  551: '#9b8161',
  552: '#9b7f6a',
  553: '#8f7982',
  554: '#c3846a',
  555: '#b67663',
  556: '#89986c',
  557: '#9b7760',
  558: '#806751',
  559: '#dabe8a',
  560: '#c7986a',
  561: '#9c8774',
  562: '#826852',
  563: '#857a64',
  564: '#677c98',
  565: '#6582a2',
  566: '#b99e93',
  567: '#8f9193',
  568: '#7a8677',
  569: '#888479',
  570: '#654f5d',
  571: '#683c47',
  572: '#ccc6c2',
  573: '#d2d0d6',
  574: '#b6acb8',
  575: '#858386',
  576: '#6f6c6d',
  577: '#b8cfaa',
  578: '#a8c9a6',
  579: '#a7c7a2',
  580: '#a3c1bb',
  581: '#d5dbda',
  582: '#cad4e3',
  583: '#bacee0',
  584: '#bed0e2',
  585: '#d0b39c',
  586: '#8d704c',
  587: '#beb49a',
  588: '#939187',
  589: '#a2807d',
  590: '#d7ccc4',
  591: '#9a8884',
  592: '#c8ccd9',
  593: '#cacfe4',
  594: '#c28e99',
  595: '#cdb866',
  596: '#c1ac7e',
  597: '#8e998d',
  598: '#88978e',
  599: '#989ba0',
  600: '#9ca1a5',
  601: '#8f959d',
  602: '#cdd7de',
  603: '#9c8b7c',
  604: '#8d8b81',
  605: '#8ab8b1',
  606: '#a68a7f',
  607: '#b9bfd8',
  608: '#697381',
  609: '#676d85',
  610: '#717d65',
  611: '#727162',
  612: '#807038',
  613: '#bfd3e4',
  614: '#cfdce1',
  615: '#8799ba',
  616: '#b9a7a2',
  617: '#8b7886',
  618: '#bd986e',
  619: '#d3b186',
  620: '#c6bcc1',
  621: '#676776',
  622: '#728e88',
  623: '#738b86',
  624: '#9a898c',
  625: '#988585',
  626: '#88775f',
  627: '#bfb8b0',
  628: '#816968',
  629: '#8b7d76',
  630: '#85736c',
  631: '#9d725d',
  632: '#807f81',
  633: '#60626d',
  634: '#5c5a61',
  635: '#64596a',
  636: '#bdaca8',
  637: '#c28e7f',
  638: '#79969b',
  639: '#887b72',
  640: '#a5b780',
  641: '#9a9699',
  642: '#969ba6',
  643: '#c9d0db',
  644: '#383f41',
  645: '#ac9693',
  646: '#919da0',
  647: '#b5aba2',
  648: '#bec4b3',
  649: '#86698a',
  650: '#aca070',
  651: '#8f8758',
  652: '#bcbea4',
  653: '#e0b67c',
  654: '#c7ab81',
  655: '#b77855',
  656: '#9ebab8',
  657: '#809bb0',
  658: '#8f8396',
  659: '#948a85',
  660: '#998f82',
  661: '#b2908c',
  662: '#a2796a',
  663: '#a37054',
  664: '#817d78',
  665: '#c1bbbb',
  666: '#bb7b93',
  667: '#987c64',
  668: '#b17a4c',
  669: '#d0a88d',
  670: '#aa9a8d',
  671: '#95978e',
  672: '#7a8677',
  673: '#7f836a',
  674: '#aeaa9b',
  675: '#7e7e80',
  676: '#ccd1c5',
  677: '#9091a2',
  678: '#a4aaba',
  679: '#7c8b94',
  680: '#ab7b8a',
  681: '#a69a8e',
  682: '#cb96a3',
  683: '#b97d99',
  684: '#ece5e9',
  685: '#ceb2bd',
  686: '#c7bfc3',
  687: '#a499ac',
  688: '#ac9f90',
  689: '#93867f',
  690: '#8a7779',
  691: '#895c5b',
  692: '#8ab5c7',
  693: '#647e97',
  694: '#c1b37a',
  695: '#b79c67',
  696: '#95847e',
  697: '#ac8782',
  698: '#aec5d0',
  699: '#b5c0c7',
  700: '#ddcad2',
  701: '#a6a294',
  702: '#bc9c64',
  703: '#b0b4bf',
  704: '#bbb1bd',
  705: '#b6aabb',
  706: '#c0b5c6',
  707: '#a69f9d',
  708: '#6d6356',
  709: '#747862',
  710: '#886c52',
  711: '#aa805d',
  712: '#c7d6e4',
  713: '#c6d4e5',
  714: '#927b98',
  715: '#706377',
  716: '#8c867c',
  717: '#8a4849',
  718: '#727d4e',
  719: '#d0c2cc',
  720: '#a89188',
  721: '#844b43',
  722: '#cabeb0',
  723: '#bebfad',
  724: '#9f8e71',
  725: '#8b6053',
  726: '#a56247',
  727: '#a05b50',
  728: '#697a9f',
  729: '#b2c9d7',
  730: '#a8bacb',
  731: '#a19694',
  732: '#99928d',
  733: '#9a8572',
  734: '#b89271',
  735: '#a28e62',
  736: '#c8a789',
  737: '#849479',
  738: '#8a8f89',
  739: '#648898',
  740: '#b0bac2',
  741: '#a9484d',
  742: '#e2dac2',
  743: '#d1c9b7',
  744: '#a99b94',
  745: '#c2b8b2',
  746: '#bcc3cc',
  747: '#92b1bd',
  748: '#828ea1',
  749: '#a08277',
  750: '#84544c',
  751: '#7e9b8e',
  752: '#a2bbb9',
  753: '#96ac99',
  754: '#d19fa2',
  755: '#d4c4ca',
  756: '#d0bbbc',
  757: '#5b4947',
  758: '#705762',
  759: '#b79ea1',
  760: '#8b7578',
  761: '#b2a48b',
  762: '#b0bb9a',
  763: '#a5a983',
  764: '#d1b38c',
  765: '#a4a2a4',
  766: '#a3a795',
  767: '#a1a1a3',
  768: '#a7afaa',
  769: '#bcb19b',
  770: '#d6a172',
  771: '#7e5661',
  772: '#716967',
  773: '#acafb3',
  774: '#846d6b',
  775: '#a3a8a9',
  776: '#aa774e',
  777: '#dcd8d1',
  778: '#a1967a',
  779: '#ad9a9d',
  780: '#c0cabd',
  781: '#646b5f',
  782: '#c1bba6',
  783: '#a79a79',
  784: '#a29675',
  785: '#9a7b45',
  786: '#af7a85',
  787: '#916350',
  788: '#70708d',
  789: '#59789f',
  790: '#9f9270',
  791: '#c1bcb4',
  792: '#868383',
  793: '#c1cdd6',
  794: '#9b4a3e',
  795: '#f5f3ef',
  796: '#8d8f8a',
  797: '#79988a',
  798: '#d4c7b4',
  799: '#656a5f',
  800: '#565451',
  801: '#b7b0ab',
  802: '#616067',
  803: '#744f88',
  804: '#755b91',
  805: '#5d625f',
  806: '#cecccc',
  807: '#a99d58',
  808: '#c5b491',
  809: '#9c9891',
  810: '#9e9c64',
  811: '#aaa35e',
  812: '#5b654f',
  813: '#d9c3bb',
  814: '#b39d95',
  815: '#b9a499',
  816: '#99aeae',
  817: '#819fa4',
  818: '#798d83',
  819: '#82776d',
  820: '#95655c',
  821: '#6b6f70',
  822: '#3e5065',
  823: '#3d3e62',
  824: '#978e90',
  825: '#b0935c',
  826: '#91514c',
  827: '#8a5241',
  828: '#87574c',
  829: '#cfa951',
  830: '#e1ddc3',
  831: '#dad6d6',
  832: '#9c9898',
  833: '#9c9889',
  834: '#8e8669',
  835: '#d0c38c',
  836: '#a7a280',
  837: '#594c48',
  838: '#423a38',
  839: '#50433f',
  840: '#b57f5f',
  841: '#a28157',
  842: '#a99564',
  843: '#a29e81',
  844: '#75705b',
  845: '#5b759c',
  846: '#a69b82',
  847: '#a08067',
  848: '#9d7fa8',
  849: '#a08c7e',
  850: '#9b483b',
  851: '#af6e33',
  852: '#c29f93',
  853: '#4e5463',
  854: '#a5afb0',
  855: '#b1b5b8',
  856: '#b5bac4',
  857: '#b6c3d0',
  858: '#bbbac7',
  859: '#b7708f',
  860: '#8d5362',
  861: '#4e5667',
  862: '#777679',
  863: '#87817d',
  864: '#e2dee0',
  865: '#a7ad93',
  866: '#7f8195',
  867: '#827373',
  868: '#e9e1c5',
  869: '#f5e0d0',
  870: '#9d7c53',
  871: '#6f5b4e',
  872: '#dbe5f1',
  873: '#d8dbe3',
  874: '#908c8c',
  875: '#b7cbd1',
  876: '#878393',
  877: '#b9ab7c',
  878: '#bb9174',
  879: '#6b7468',
  880: '#9d7a60',
  881: '#aec1c6',
  882: '#84808a',
  883: '#95b2c8',
  884: '#bcbdc3',
  885: '#849785',
  886: '#718685',
  887: '#84a3a2',
  888: '#7e7e94',
  889: '#704e5f',
  890: '#7a3e5e',
  891: '#b1aea9',
  892: '#6c6c67',
  893: '#424a3e',
  894: '#d3d88a',
  895: '#61444e',
  896: '#c6cedf',
  897: '#625c80',
  898: '#687876',
  899: '#ccc5bd',
  900: '#695949',
  901: '#80736a',
  902: '#a89b98',
  903: '#85879f',
  904: '#83797b',
  905: '#b09aa7',
};
